module.exports = __webpack_public_path__ + "img/sigin-ecnu-logo.bc4a7925.png";